import { useRef, useState } from "react";
import { Loader2, Upload, X, FileText } from "lucide-react";
import { toast } from "sonner";
import api from "@/lib/api";

const BACKEND = process.env.REACT_APP_BACKEND_URL;
export const fileSrc = (u) => (!u ? "" : u.startsWith("http") ? u : `${BACKEND}${u}`);
export const inp = "w-full rounded-lg border border-neutral-700 bg-black/30 px-3 py-2 text-sm text-white outline-none transition-colors focus:border-[#C17F59]";

export const Lbl = ({ children, hint }) => (
  <div className="mb-1 flex items-baseline justify-between gap-2 text-[11px] font-bold uppercase tracking-widest text-neutral-400">
    <span>{children}</span>{hint && <span className="normal-case tracking-normal text-neutral-500">{hint}</span>}
  </div>
);

export const Field = ({ label, hint, value, onChange, testid, area, rows = 4, ...rest }) => (
  <div>
    <Lbl hint={hint}>{label}</Lbl>
    {area
      ? <textarea rows={rows} className={inp} value={value ?? ""} onChange={(e) => onChange(e.target.value)} data-testid={testid} {...rest} />
      : <input className={inp} value={value ?? ""} onChange={(e) => onChange(e.target.value)} data-testid={testid} {...rest} />}
  </div>
);

export function UploadBtn({ api: up, kind = "foto", onUrl, label = "Carica", testid, accept = "image/*" }) {
  const ref = useRef(null);
  const [busy, setBusy] = useState(false);
  const pick = async (e) => {
    const f = e.target.files?.[0];
    e.target.value = "";
    if (!f) return;
    setBusy(true);
    const fd = new FormData();
    fd.append("file", f);
    try { const r = await api.post(up.url, fd, { params: { ...up.params, kind }, timeout: 120000 }); onUrl(r.data.url); }
    catch (err) { toast.error(err.response?.data?.detail || "Upload non riuscito"); }
    setBusy(false);
  };
  return (
    <>
      <input ref={ref} type="file" accept={accept} className="hidden" onChange={pick} data-testid={`${testid}-input`} />
      <button type="button" onClick={() => ref.current?.click()} disabled={busy} data-testid={testid}
        className="inline-flex items-center gap-1.5 rounded-full border border-neutral-700 px-3 py-1.5 text-xs font-semibold text-neutral-200 transition-colors hover:border-[#C17F59]">
        {busy ? <Loader2 className="h-3.5 w-3.5 animate-spin" /> : <Upload className="h-3.5 w-3.5" />}{label}
      </button>
    </>
  );
}

export const ImageSlot = ({ url, onChange, up, kind, label, hint, testid, wide }) => (
  <div>
    <Lbl hint={hint}>{label}</Lbl>
    <div className="flex items-center gap-3">
      <div className={`${wide ? "h-24 w-44" : "h-20 w-20"} shrink-0 overflow-hidden rounded-lg border border-neutral-800 bg-neutral-900`}>
        {url && <img src={fileSrc(url)} alt="" className="h-full w-full object-cover" data-testid={`${testid}-img`} />}
      </div>
      <UploadBtn api={up} kind={kind} onUrl={onChange} testid={`${testid}-upload`} label={url ? "Sostituisci" : "Carica"} />
      {url && <button type="button" onClick={() => onChange("")} className="text-neutral-500 hover:text-red-400" data-testid={`${testid}-remove`}><X className="h-4 w-4" /></button>}
    </div>
  </div>
);

export const PdfSlot = ({ url, onChange, up, testid }) => (
  <div>
    <Lbl>Company profile (PDF)</Lbl>
    <div className="flex items-center gap-3">
      {url && <a href={fileSrc(url)} target="_blank" rel="noreferrer" className="inline-flex items-center gap-1 text-xs text-[#C17F59] underline" data-testid={`${testid}-link`}><FileText className="h-4 w-4" />Apri PDF</a>}
      <UploadBtn api={up} kind="pdf" accept="application/pdf" onUrl={onChange} testid={`${testid}-upload`} label={url ? "Sostituisci" : "Carica PDF"} />
      {url && <button type="button" onClick={() => onChange("")} className="text-neutral-500 hover:text-red-400" data-testid={`${testid}-remove`}><X className="h-4 w-4" /></button>}
    </div>
  </div>
);
